import { FC } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

// Helpers
import useCoachMenuItems from "@/_configs/coach_menu";

// Services and interfaces
import { useGetCoachQuery } from "@/repositories/coach";

// Components
import { Box } from "@mui/material";
import Avatar from "@/components/avatar";
import NavSideMenu from "@/components/navigation/side_menu";


const CoachPage: FC = () => {

    const { id } = useParams()
    const navigate = useNavigate()
    const menuItems = useCoachMenuItems(id!);
    const { data: coach, isLoading } = useGetCoachQuery(id!)

    const back = () => navigate('/coach/list')

    return (
        <Box height='calc(100vh - 40px)' display='flex' overflow='hidden'>

            <NavSideMenu 
                kind='ghost'
                onBack={back}
                avatar={
                    <Avatar 
                        size="small"
                        name={coach?.full_name ?? ''}
                        src={coach?.avatar ?? ''}
                        sx={{mr: 1}}
                    /> 
                }
                label={coach?.full_name}
                items={menuItems}
                isLoading={isLoading}
                />
     
            {/* Main content */}
            <Box display='flex' flexDirection='column' width='100%' height='100%'>
                <Box flexGrow={1} overflow='hidden'>
                    <Outlet />
                </Box>
            </Box>

        </Box>
    );
}

export default CoachPage;